export type RecoveryPhase = 'form' | 'otp' | 'completing' | 'addendum'

export interface RecoveryState {
  phase: RecoveryPhase
  email?: string
  otpId?: string
  token?: string
  customerId?: string
}

export type RecoveryAction =
  | { type: 'EMAIL_EXISTS'; email: string }
  | { type: 'OTP_SENT'; otpId: string }
  | { type: 'VERIFIED'; token: string; customerId: string; hasActiveLease: boolean }
  | { type: 'RESET' }

export const initialRecoveryState: RecoveryState = { phase: 'form' }

export function recoveryReducer(state: RecoveryState, action: RecoveryAction): RecoveryState {
  switch (action.type) {
    case 'EMAIL_EXISTS':
      return { phase: 'otp', email: action.email }
    case 'OTP_SENT':
      return { ...state, otpId: action.otpId }
    case 'VERIFIED':
      return {
        ...state,
        phase: action.hasActiveLease ? 'addendum' : 'completing',
        token: action.token,
        customerId: action.customerId,
      }
    case 'RESET':
      return initialRecoveryState
    default:
      return state
  }
}
